import React, { FC } from 'react'
import { Text } from '@shared/ui/Typography/Text'
import s from '@widgets/Common/Footer/Footer.module.sass'
import { EGG } from '@shared/api/analytics'
import { openModal } from '@widgets/Common/ModalFeedback/model/actions'
import { useAppDispatch } from '@app/model/store'

export const FooterFoundMistakeOpener: FC = () => {
  const dispatch = useAppDispatch()

  const handleOpenFoundMistake = () => {
    EGG.footer.menu_item_click({ button_name: 'Нашли ошибку?' })
    dispatch(openModal())
  }

  return (
    <button onClick={handleOpenFoundMistake} type='button'>
      <Text tag={'span'} sizes={'S M'} className={s['navigation-link']}>
        Нашли ошибку?
      </Text>
    </button>
  )
}
